import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import store from '@/state/store';
import axios from 'axios';

// Only include the minimal imports needed for the landing page
import '@/assets/scss/app.scss';

// Create the Vue app with just the necessary features
const app = createApp(App);

app.use(store)
  .use(router)
  .use(i18n)
  .mount('#app'); 